import { Textual }	from "@v3/data/textual";

// ATTENTION this is always lowercase
// ATTENTION this does not support embedded ipv4 addresses
export type IpV6	= Textual.Value<typeof Base>;

const Base	=
	Textual.predicate(
		"IpV6",
		it => valid(it),
		"must be an ip address version 6"
	);

const valid	= (str:string):boolean	=> {
	const groups	= str.split("::").map(parts);
	switch (groups.length) {
		case 1:
			const only	= groups[0];
			return only !== null && only === 8;
		case 2:
			const left	= groups[0];
			const right	= groups[1];
			return left !== null && right !== null && left + right < 8;
		default:
			return false;
	}
};

// how many numbers separated by ":" we have, or null when a part is invalid
const parts	= (str:string):number|null	=> {
	if (str === "")	return 0;
	const parts	= str.split(":");
	const ok	= parts.every(it => /^[0-9a-f]{1,4}$/.test(it));
	return ok ? parts.length : null;
};

namespace Extension {
	// external data may be uppercase
	export const reallyParse	= (it:string):IpV6|null => Base.fromString(it.toLowerCase());
}

export const IpV6	= { ...Extension, ...Base };
